
import {

  FETCH_STOCKCONSUMPTION_REQUEST,
  FETCH_STOCKCONSUMPTION_SUCCESS,
  FETCH_STOCKCONSUMPTION_FAILURE,

  CREATE_STOCKCONSUMPTION_REQUEST,
  CREATE_STOCKCONSUMPTION_SUCCESS,
  CREATE_STOCKCONSUMPTION_FAILURE,

  UPDATE_STOCKCONSUMPTION_REQUEST,
  UPDATE_STOCKCONSUMPTION_SUCCESS,
  UPDATE_STOCKCONSUMPTION_FAILURE,

  DELETE_STOCKCONSUMPTION_REQUEST,
  DELETE_STOCKCONSUMPTION_SUCCESS,
  DELETE_STOCKCONSUMPTION_FAILURE,
} from "./stockConsumptionActionTypes";

const initialState = {
  stockconsum: [],
  loading: false,
  error: null,
};

const stockConsumptionReducer = (state = initialState, action) => {
  switch (action.type) {
   
    case FETCH_STOCKCONSUMPTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_STOCKCONSUMPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        stockconsum: action.payload,
      };
    case FETCH_STOCKCONSUMPTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        stockconsum: [],
      };

    case CREATE_STOCKCONSUMPTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_STOCKCONSUMPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        stockconsum: action.payload,
        error: null,
      };
    case CREATE_STOCKCONSUMPTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_STOCKCONSUMPTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_STOCKCONSUMPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        stockconsum: action.payload,
        error: null,
      };
    case UPDATE_STOCKCONSUMPTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_STOCKCONSUMPTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_STOCKCONSUMPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        stockconsum: action.payload,
        error: null,
      };
    case DELETE_STOCKCONSUMPTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default stockConsumptionReducer;
